<template>
    <div
        class="grid grid-cols-7 gap-px text-center text-sm font-medium leading-tight text-slate-500 lg:flex-none"
    >
        <div
            v-for="(weekday, wIndex) in weekdays"
            class="flex bg-white"
            :class="classes"
            :key="'weekday-' + wIndex"
        >
            <span>{{ weekdayLabel(weekday) }}</span>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCalendarStore } from '@/store/calendar';

export default {
    name: 'Weekdays',
    props: {
        size: {
            type: String,
            default: 'full',
        },
    },
    data: () => ({}),
    computed: {
        ...mapState(useCalendarStore, ['loading', 'weekdays', 'activeDate']),
        classes() {
            return this.size === 'full'
                ? 'justify-end pb-4 pr-2'
                : 'justify-center pb-4';
        },
    },
    methods: {
        ...mapActions(useCalendarStore, ['setLoading']),
        weekdayLabel(weekday) {
            return this.size === 'full' ? weekday.short : weekday.shorter;
        },
    },
    mounted() {},
};
</script>
